import { Text } from '@mantine/core';
import { IconBulb } from '@tabler/icons-react';
import { match } from 'ts-pattern';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';

export function AITipCard({ message }: { message: Extract<AIMessage, { type: 'tip' }> }) {
  const categoryLabel = match(message.category)
    .with('latency', () => 'Performance')
    .with('accuracy', () => 'Accuracy')
    .with('maintainability', () => 'Maintainability')
    .with('other', () => 'General')
    .with(undefined, () => undefined)
    .exhaustive();

  return (
    <CollapsibleCard
      icon={IconBulb}
      title="Tip"
      badge={categoryLabel}
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-500 dark:text-gray-400',
      }}
    >
      <div>
        <Text
          size="sm"
          className="leading-relaxed"
        >
          {message.content}
        </Text>
      </div>
    </CollapsibleCard>
  );
}
